import "./App.css";

import { AuthProvider } from "./context/auth";
import AuthenticatedApp from "./AuthentictedApp";
import Loader from "./components/loader/Loader";
import UnAuthenticatedApp from "./UnauthenticatedApp";

function App() {
  return (
    <AuthProvider
      whenLoading={<Loader />}
      whenAuthenticated={<AuthenticatedApp />}
      whenUnAuthenticated={<UnAuthenticatedApp />}
    />
  );
}

export default App;
